export default __webpack_public_path__ + "static/media/avatar.256ef3c8.jpg";